import update from 'immutability-helper';
import * as types from './types';

export const initialState = {
  savePromptVisibility: false,
  activeDashboardId: null,
  updatePopupVisible: {},
  removePopupVisible: false,
};

export default (state = initialState, action) => {
  const switchMap = {};

  switchMap[types.SET_ACTIVE_DASHBOARD_ID] = () => update(state, {
    activeDashboardId: { $set: action.id || null },
  });

  switchMap[types.SAVE_DASHBOARD_PROMPT_VISIBILITY] = () => update(state, {
    savePromptVisibility: { $set: action.flag },
    activeDashboardId: { $set: action.id || null },
  });

  switchMap[types.TOGGLE_UPDATE_POPUP_VISIBLE] = () => update(state, {
    updatePopupVisible: {
      $set: {
        [action.id]: action.visible,
      },
    },
  });

  switchMap[types.TOGGLE_REMOVE_POPUP_VISIBLE] = () => update(state, {
    removePopupVisible: {
      $set: !state.removePopupVisible,
    },
  });

  return switchMap[action.type]
    ? switchMap[action.type]()
    : state;
};
